import { getVideoUrl } from '@/src/services';

interface Props {
    media: { id: string },
    playsInline?: boolean,
    autoPlay?: boolean,
    loop?: boolean,
    muted?: boolean,
    className?: string,
    onCloseClick?: () => void,
    controls?: boolean
}

export const VideoPlayer = (props: Props) => {


    const { media, playsInline = true, autoPlay = false, loop = false, muted = true, controls = true } = props;

    return (
        <video controls={controls} key={media.id}
            style={{ width: "100%", height: "100%" }}
           
            muted={muted} loop={loop} autoPlay={autoPlay} playsInline={playsInline}
        >
            <source src={getVideoUrl(media, "video/webm")} type={"video/webm"} />
            <source src={getVideoUrl(media, "video/mp4")} type={"video/mp4"} />
        </video>
    );
};
